import { EToken } from '@prisma/client';
import { encodeURL } from '@solana/pay';
import { puffToken, solToken, usdcToken, usdtToken } from '../../config/config';
import { getBaseURI } from '../../utils/utils';
import { ComputeBudgetProgram } from '@solana/web3.js';

export const tokenToMintMap = {
  [EToken.PUFF]: {
    mint: puffToken,
    decimals: 9,
    symbol: EToken.PUFF,
  },
  [EToken.USDC]: {
    mint: usdcToken,
    decimals: 6,
    symbol: EToken.USDC,
  },
  [EToken.SOL]: {
    mint: solToken,
    decimals: 9,
    symbol: EToken.SOL,
  },
  [EToken.USDT]: {
    mint: usdtToken,
    decimals: 6,
    symbol: EToken.USDT,
  }
}

export function getSolanaPayLink(paymentId: string) {
  const baseUri = getBaseURI()

  return `solana:${baseUri}/api/pay/${paymentId}`
}


export function addPriorityFee(microLamports?: number) {
  return ComputeBudgetProgram.setComputeUnitPrice({
    microLamports: microLamports ?? 100001,
  })
}